import { GridColDef } from '@mui/x-data-grid';
import React from 'react';
import { SiblingStatusWrapper, StatusCircularDot } from '../styled';
import pallet from '../../../layouts/pallet';

export const getSiblingColumns = (): GridColDef[] => {
  return [
    {
      field: 'status',
      headerName: 'Status',
      minWidth: 120,
      renderCell: (params) => {
        const isInactive = params.value === 'IN_ACTIVE';
        const bgColor = isInactive ? pallet.lightRed : pallet.lightGreen;
        const textColor = isInactive ? pallet.red2 : pallet.green2;
        const circleColor = isInactive ? pallet.red2 : pallet.green2;

        return (
          <SiblingStatusWrapper backgroundColor={bgColor} color={textColor}>
            <StatusCircularDot circleColor={circleColor} />
            {params.value === 'IN_ACTIVE' ? 'Inactive': 'Active'}
          </SiblingStatusWrapper>
        );
      }
    },
    { field: 'enrollmentNo', headerName: 'Enrollment No', minWidth: 150 },
    { field: 'name', headerName: 'Name', flex: 1 },
    { field: 'class', headerName: 'Class', minWidth: 100 }
  ];
};
